<template>
	<div>
		<q-dialog v-model="show_modal" maximized>
			<q-card class="card-main bg-black text-white">
				<q-toolbar>
					<q-toolbar-title></q-toolbar-title>
					<q-btn flat round dense icon="fal fa-times" @click="show_modal = false" />
				</q-toolbar>

				<q-separator />

				<q-card-section class="q-pa-md">
					<div class="row q-col-gutter-lg">
						<div class="col-12">
							<q-table
								dark
								:data="user_podcasts"
								:columns="columns"
								row-key="id"
								:pagination.sync="server_pagination"
								:loading="loading"
								:filter="filter"
								selection="multiple"
								:no-data-label="$t('no_data_avaliable')"
								:no-results-label="$t('no_results_found')"
								:loading-label="$t('loading_data')"
								:rows-per-page-label="$t('items_per_page')"
								:rows-per-page-options="[5, 10, 50, 100]"
								@request="fetchUserPodcast"
								binary-state-sort
							>
								<template v-slot:top>
									<div class="row items-center">
										<div class="col-5">
											<q-input
												borderless
												dark
												debounce="300"
												color="primary"
												v-model="filter"
												:placeholder="$t('search')"
											>
												<template v-slot:prepend>
													<q-icon name="far fa-search" />
												</template>
											</q-input>
										</div>
										<div class="col-7 flex justify-end">
											<q-btn
												color="primary"
												:disable="loading"
												:label="$t('new_playlist')"
												@click="show_modal_new_playlist = true"
											/>
										</div>
									</div>
								</template>
								<template v-slot:header="props">
									<q-tr :props="props">
										<q-th v-for="col in props.cols" :key="col.name" :props="props">
											{{ $t(col.label) }}
										</q-th>
									</q-tr>
								</template>

								<template v-slot:body="props">
									<q-tr :props="props">
										<q-td key="title" :props="props">
											{{ props.row.title }}
										</q-td>
										<q-td key="qty_podcast_playlist_audio" :props="props">
											{{ props.row.qty_podcast_playlist_audio }}
										</q-td>
										<q-td key="id" :props="props">
											<q-btn
												color="primary"
												:disable="loading"
												:label="$t('add_playlist')"
												@click="addPlaylist(props.row)"
											/>
										</q-td>
									</q-tr>
								</template>
							</q-table>
						</div>
					</div>
				</q-card-section>
			</q-card>
		</q-dialog>

		<q-dialog v-model="show_modal_new_playlist" persistent>
			<q-card class="bg-grey-9 text-white" style="width: 100%">
				<q-card-section>
					<div class="text-h6">{{ $t('title') }}</div>
				</q-card-section>

				<q-card-section class="q-pt-none">
					<q-input
						dark
						dense
						v-model="name"
						color="black"
						autofocus
						@keyup.enter="prompt = false"
					/>
				</q-card-section>

				<q-card-actions align="right" class="text-primary">
					<q-btn flat color="white" :label="$t('cancel')" v-close-popup />
					<q-btn flat color="white" :label="$t('new_playlist')" @click="createPlaylist()" />
				</q-card-actions>
			</q-card>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	props: ['show'],
	i18nOptions: { namespaces: ['custom', 'common', 'podcasts'] },
	data() {
		return {
			user_podcasts: [],
			loading: false,
			filter: '',
			name: '',
			show_modal_new_playlist: false,
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				sortBy: null,
			},
			columns: [
				{ name: 'title', align: 'title', label: 'title', field: 'title', sortable: true },
				{
					name: 'qty_podcast_playlist_audio',
					label: 'episode',
					field: 'qty_podcast_playlist_audio',
					sortable: true,
				},
				{ name: 'id', label: '', field: 'id' },
			],
		}
	},

	computed: {
		...mapGetters({
			playlist: 'podcasts/playlist',
		}),

		show_modal: {
			get() {
				return this.show
			},
			set() {
				this.$emit('closeModal', [])
			},
		},
	},

	methods: {
		fetchUserPodcast({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: this.filter_selected,
				ordering: order_by,
				is_selected: true,
			}

			this.$axios
				.get(`/etraining_podcast/playlist_user/?${this.$qs.stringify(data)}`)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					this.user_podcasts = []
					this.user_podcasts = response.data.results
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		addPlaylist(podcast) {
			let fd = {
				title: podcast.title,
				audios: [...podcast.audios, ...this.playlist],
			}
			this.$q.loading.show()

			this.$axios
				.put(`/etraining_podcast/playlist_user/${podcast.id}/`, fd)
				.then((response) => {
					this.$store.dispatch('podcasts/SET_PLAYLIST', [[]])
					this.show_modal = false
					this.$q.notify({
						message: this.$t('playlist_save_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
					this.$q.notify({
						message: this.$t('unexpected_error_try_again_later'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		createPlaylist() {
			let fd = {
				title: this.name,
				audios: this.playlist,
			}
			this.$q.loading.show()

			this.$axios
				.post(`/etraining_podcast/playlist_user/`, fd)
				.then((response) => {
					this.$store.dispatch('podcasts/SET_PLAYLIST', [[]])
					this.show_modal = false
					this.$q.notify({
						message: this.$t('playlist_save_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
					this.$q.notify({
						message: this.$t('unexpected_error_try_again_later'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
				})
				.finally(() => {
					this.$q.loading.hide()
					this.show_modal_new_playlist = false
				})
		},
	},
	watch: {
		show: function () {
			if (this.show) this.fetchUserPodcast({ pagination: this.server_pagination })
		},
	},
}
</script>

<style lang="scss" scoped>
@media (min-width: $breakpoint-sm-min) {
	.card-main {
		min-width: 70vw;
		width: 70vw;
		height: 85vh;
	}
	.card-player {
		width: 70%;
	}
}
@media (min-width: $breakpoint-lg-min) {
	.card-main {
		min-width: 55vw;
		width: 55vw;
		height: 80vh;
	}
	.card-player {
		width: 85%;
	}
}
.card-player {
	margin: 0 auto;
}
</style>
